export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7740.32916e35.jpg";